let tech_sech = [
  {
    id: 1,
    title: "Major Components",
    fetures: [
      "Slide or Cartridge holding stage",
      "XYZ motion stage",
      "Optics unit with Turret mechanism unit",
      "Optics digital camera",
      "Display unit",
      "Control unit",
      "Casing",
    ],
  },
  {
    id: 2,
    title: "Compatible Optional Analyser Softwares",
    fetures: [
      "Sigtuple Shonit- Blood Analyser",
      "Sigtuple Shrava- Urine Analyser",
    ],
  },
  {
    id: 3,
    title: "Camera",
    fetures: ["CMOS sensor", "14 MegaPixel resolution"],
  },
  {
    id: 4,
    title: "Optics system",
    fetures: [
      "Single optical column",
      "40X Objective lens",
      "Optical resolution of approx. 700 lp/mm",
      "Digital resolution of approx. 6.1 pixels/micron",
    ],
  },
  {
    id: 5,
    title: "Illumination source",
    fetures: ["White LED"],
  },
  {
    id: 6,
    title: "Stage movement resolution",
    fetures: ["XY axis - 0.25 um", "Z axis - 0.06 um"],
  },
  {
    id: 7,
    title: "Travel Speed",
    fetures: ["XY axis - 12 mm /sec", "Z axis - 3 mm/ sec"],
  },
  {
    id: 8,
    title: "Barcode reader",
    fetures: ["External barcode reader"],
  },
  {
    id: 9,
    title: "Quality Control",
    fetures: [
      "Sigtuple Performance Qualification test for hardware and image quality",
      "Built-in assessment test of Sample preparation quality",
    ],
  },
  {
    id: 10,
    title: "Archiving of results and images",
    fetures: [
      "Unlimited archiving in Sigtuple Mandara utilizing either LAN or WiFi",
      "XYZ motion stage",
      "Optics unit with Turret mechanism unit",
      "Optics digital camera",
      "Display unit",
      "Control unit",
      "Casing",
    ],
  },
  {
    id: 11,
    title: "External interface",
    fetures: ["USB, Ethernet"],
  },
  {
    id: 12,
    title: "Electrical specification",
    fetures: [
      "Input voltage - 100-240 VAC",
      "Nominal Power- 60 watt",
      "AC Frequency - 50/60Hz",
    ],
  },
  {
    id: 13,
    title: "Size (W x D x H)",
    fetures: ["485 x 572 x 485 mm /", "19.1 x 22.52 x 19.1 inches"],
  },
  {
    id: 14,
    title: "Weight",
    fetures: ["49 kg / 108 lbs"],
  },
  {
    id: 15,
    title: "Regulatory Approval",
    fetures: ["CE"],
  },
];

export default tech_sech;
